import styles from './RelatedProducts.module.css'
import SectionHeader from './SectionHeader'
import Carousel from './Carousel'
import DealHuntProductCard from './DealHuntProductCard'
import type { ProductCardModel } from './cardModel'

interface RelatedProductsProps {
  products: ProductCardModel[]
  title?: string
  /** "See our top picks ›" target — the product's own category page, pre-sorted
   *  by SoundGuys score. Falls back to the Audio root listing. */
  topPicksHref?: string
}

/**
 * "Related products" carousel. Reuses the category/search grid card
 * (`DealHuntProductCard` with `ctaToRetailer`) so the rail matches
 * the category listing: category label, optional SG score + "Read our review", price,
 * and a "Buy on Amazon" CTA. The score chip, badge, and price each render only when
 * the hit carries them — the direct-Meili rail source (see `fetchRelatedProducts`)
 * omits the SG editorial fields, so those cards simply show without a score/badge.
 */
const RelatedProducts: React.VFC<RelatedProductsProps> = ({
  products,
  title = 'Related products',
  topPicksHref,
}) => {
  if (!products?.length) {
    return null
  }

  return (
    <section className={styles.section}>
      <SectionHeader
        title={title}
        link={{
          href: topPicksHref ?? '/product/audio',
          label: 'See our top picks ›',
          external: false,
        }}
      />

      <Carousel>
        {products.map((product, i) => (
          <DealHuntProductCard
            key={product.key}
            product={product}
            ctaToRetailer
            className={styles.card}
            list={{ list_name: 'related', position: i + 1 }}
          />
        ))}
      </Carousel>
    </section>
  )
}

export default RelatedProducts
